import { cardItems } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">精选推荐</h2>
            <p className="mt-3 text-sm text-foreground-600">编辑精选高分影视，热播大剧一网打尽</p>
          </div>
          <a href="#index" className="hidden md:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-300/40 transition-colors">
              <div className="relative h-44 overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute top-2.5 left-2.5 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 font-heading leading-snug line-clamp-2">{item.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}